<template>
  <div class="tabs">
    <nav class="tabs-header">
      <a
        v-for="(tab, index) in tabList"
        :key="tab.tabKey || index"
        class="tabs-cell"
        :class="{ active: tab === activeTab }"
        @click="setActive(tab, index)"
      >
        {{ tab.title }}
        <span v-if="tab.content"> {{ tab.content }} </span>
      </a>
    </nav>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Tabs',
  props: ['value'],
  model: {
    prop: 'value',
    event: 'on-change'
  },
  watch: {
    $children() {
      this.setTabList()
    },
    value(val) {
      if (val) {
        const tab = this.getActiveTab(val)
        this.setActive(tab)
      }
    }
  },
  data: function() {
    return {
      tabList: [],
      activeTab: null
    }
  },
  mounted() {
    this.setTabList()
    const activeTab = this.getActiveTab(this.value)
    this.activeTab = activeTab || this.tabList[0]

    this.activeTab.show()
  },
  methods: {
    getActiveTab(val) {
      return this.tabList.find((tab, index) => (tab.tabKey || index) === val)
    },
    setTabList() {
      if (!this.$children || this.$children.length === 0) {
        this.tabList = []
      } else {
        this.tabList = this.$children
      }
    },
    setActive(tab, index) {
      if (this.activeTab !== tab) {
        this.activeTab.hide()
        // 避免show过快，上一个页面还没有完全隐藏
        this.$nextTick(() => {
          this.activeTab = tab
          this.activeTab.show()
          this.$emit('active', tab, index)
          this.$emit('on-change', tab.tabKey || index)
        })
      }
    },
    reset() {
      this.setActive(this.tabList[0])
    }
  }
}
</script>
<style lang="less" scoped>
.tabs {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}
.tabs-cell {
  position: relative;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  color: var(--default-font-color);

  &.active {
    color: var(--active-color);
  }
}
</style>
